import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ServiceTemplate } from 'src/app/models/interface/serviceTemplate/serviceTemplate';
import { ServiceTemplateCharValue } from 'src/app/models/interface/serviceTemplate/serviceTemplateCharValue';
import { ServiceTemplateDataElement } from 'src/app/models/interface/serviceTemplate/serviceTemplateDataElement';
import { ServiceTemplateRequest } from 'src/app/models/interface/serviceTemplate/serviceTemplateRequest';
import { CatalogService } from 'src/app/services/api/catalog/catalog.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { TemplatesService } from 'src/app/services/api/templates/templates.service';

@Component({
  selector: 'app-dialog-edit-service-template',
  templateUrl: './dialog-edit-service-template.component.html',
  styleUrls: ['./dialog-edit-service-template.component.scss']
})
export class DialogEditServiceTemplateComponent implements OnInit {

  form: FormGroup;
  initialValue: ServiceTemplate;
  currentValue: ServiceTemplate;

  serviceTemplateCharValues: any[];

  tooltip = {
    submit: '',
    reset: ''
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ServiceTemplateDataElement,
    public dialogRef: MatDialogRef<DialogEditServiceTemplateComponent>,
    private templatesService: TemplatesService,
    private translate: TranslateService,
    private notificationsService: NotificationsService,
    private catalogService: CatalogService
  ) {
  }

  ngOnInit() {
    this.serviceTemplateCharValues = [];
    this.initialValue = this.data.element;

    this.form = new FormGroup({
      serviceTemplateName: new FormControl(this.data.element.name, Validators.required),
      version: new FormControl(this.data.element.version, Validators.required),
      spec: new FormControl(this.data.element.spec_id, Validators.required),   
    });

    this.catalogService.getCustomServiceSpec(this.form.controls['spec'].value).subscribe(data => {
      var sortedServiceSpecServiceChars = data.serviceSpecServiceChars.sort((a,b) =>
      a.serviceCharRef.namingId.toLowerCase() < b.serviceCharRef.namingId.toLowerCase() ? -1 : 1 );
      for (let serviceChar of sortedServiceSpecServiceChars) {
        const charValue: ServiceTemplateCharValue = this.initialValue.serviceTemplateCharValues.find(charValue => charValue.name === serviceChar.serviceCharRef.namingId);
        const validators = serviceChar.mandatory ? [Validators.required] : [];
        this.form.addControl(serviceChar.serviceCharRef.namingId, new FormControl(charValue.value, validators));
      }
      this.serviceTemplateCharValues = data.serviceSpecServiceChars;
    })

    this.initTooltips();
  }

  public submitForm() {
    if (this.form.valid) {
      const serviceTemplateRequest: ServiceTemplateRequest = {
        namingId: "Profile_" + this.form.controls['serviceTemplateName'].value + "_v" + this.form.controls['version'].value,
        name: this.form.controls['serviceTemplateName'].value,
        version: this.form.controls['version'].value,
        specId: this.form.controls['spec'].value,
        state: 'ACTIVE',
        serviceTemplateCharValues: []
      };
  
      for (const serviceTemplateCharValue of this.serviceTemplateCharValues) {
        serviceTemplateRequest.serviceTemplateCharValues.push({
          value: this.form.controls[serviceTemplateCharValue.serviceCharRef.namingId].value,
          name: serviceTemplateCharValue.serviceCharRef.namingId
        })
      }
  
      this.catalogService.updateServiceTemplate(this.initialValue.namingId, serviceTemplateRequest)
        .subscribe(
          () => {
            this.notificationsService.showNotification(`ServiceTemplate ${this.initialValue.name} modificada correctamente`, NotificationLevel.SUCCESS);
            this.dialogRef.close();
          },
          (error) => {
            this.notificationsService.showNotification(
              `Ha habido un problema al editar el serviceTemplate:\n${error.error.errorDesc.errorDesc}`, NotificationLevel.ERROR);
          });
    } else {
      this.notificationsService.showNotification('Por favor, complete todos los campos obligatorios.', NotificationLevel.ERROR);
    }
  }

  clearForm() {
    this.form.reset();
  }

  private initTooltips() {
    this.translate.get('DUMMY.key').subscribe((translated: string) => {
      this.tooltip.submit = this.translate.instant('TOOLTIPS.submitForm');
      this.tooltip.reset = this.translate.instant('TOOLTIPS.resetForm');
    });
  }

}
